import React from 'react';
import { useParams } from 'react-router-dom';
import { fleetAPI } from '../services/api';
import TripHistory from '../components/TripHistory';
import { expiryBadges } from './VehiclesPage';
import { AlertTriangle } from 'lucide-react';

export default function VehicleView() {
  const { id } = useParams();
  return (
    <TripHistory
      title="Vehicle Trip History"
      subtitle="All LR trips recorded against this vehicle"
      api={fleetAPI.vehicles}
      entityId={id}
      fileLabel="vehicle"
      entityCard={(data) => {
        const v = data.vehicle || {};
        const badges = expiryBadges(v);
        return (
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-md p-4 flex flex-wrap gap-x-8 gap-y-2" data-testid="vehicle-detail-card">
            <Info label="Vehicle No." value={v.vehicle_number} mono />
            <Info label="Type" value={v.vehicle_type} />
            <Info label="Capacity" value={v.capacity} />
            <Info label="Owner" value={v.owner_name} />
            <Info label="Owner Mobile" value={v.owner_mobile} mono />
            <Info label="GPS" value={v.gps_enabled ? 'Yes' : 'No'} />
            <Info label="Status" value={v.status} />
            {badges.length > 0 && (
              <div className="flex flex-wrap items-center gap-1">
                {badges.map((b, i) => <span key={i} className={`inline-flex items-center gap-0.5 text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${b.cls}`}><AlertTriangle className="w-2.5 h-2.5" />{b.label}</span>)}
              </div>
            )}
          </div>
        );
      }}
    />
  );
}

function Info({ label, value, mono }) {
  return (
    <div className="min-w-0">
      <p className="text-[10px] text-slate-400 uppercase tracking-wide">{label}</p>
      <p className={`text-sm font-medium text-slate-800 dark:text-slate-200 ${mono ? 'font-mono' : ''}`}>{value || '—'}</p>
    </div>
  );
}
